import routes from './routeConfig'
import { isFeatureEnabled } from 'src/features'

type HaveRight = (right: string) => boolean

const normalizeRoutePath = (path: string) => {
  const cleanPath = path.split('?')[0].replace(/^\/+/, '')
  return cleanPath === '' ? '/' : `/${cleanPath}`
}

export const routeRightForPath = (path: string) => {
  const normalizedPath = normalizeRoutePath(path)
  return Object.values(routes).find(route => route.paths.includes(normalizedPath))?.right
}

export const canSeeRoutePath = (path: string, haveRight: HaveRight) => {
  const normalizedPath = normalizeRoutePath(path)
  const route = Object.values(routes).find(route => route.paths.includes(normalizedPath))
  if (!route || !isFeatureEnabled(route.feature)) return false

  const right = route.right
  return !right || haveRight(right)
}
